// removed by extract-text-webpack-plugin
module.exports = {"shippingAddressModal":"Ow2aB","shippingAddressModalContents":"_12Sqd","header":"_3dhow","shippingAddressButton":"_3xErp","editShippingAddressButton":"_10Nts","enterManuallySection":"_3n4wr","checkbox":"_2IkQO","checkboxLabel":"c-NiQ","continueButton":"_2fZvy","error":"_3wjgk","input":"_39DJM","halfInput":"_2QTes _39DJM","inputInvalid":"_1SHaZ","closeButton":"WCDjC","removeButton":"gli2t"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/ShippingAddressModal/index.sass
// module id = 1503
// module chunks = 1